import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Whychoose(props) {
    return (
        <section className=" p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Services Oracle">
                            <h2>Oracle Solutions Provider For Business Modernization</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <p>Oracle is currently powering some of the most prominent tech-enabled solutions for internal business process management and external stakeholder experiences. Its cloud applications and infrastructure help developers strategically deliver business value,Our Oracle solutions providers have enabled businesses to achieve the following business benefits with consulting and implementation.Reduced operational and business costs.Multi-tenant support across diverse internal and external departments.Efficient DevOps management enables faster technical delivery.Optimal data performance, with avenues for backup and recovery,Have other use cases for Oracle services?</p>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Whychoose;